<template>
  <div style="width:100%; height: 100%;">
    <v-navigation-drawer
        :right="true"
         dark
         v-show="drawerFilter"
         color="teal darken-2"
        :mini-variant="true"
        :hide-overlay="true"
        fixed
      permanent
      :disable-resize-watcher="true"
      :clipped="true"


      >
      <v-list dense>
        <v-list-item-group v-model="f" style="padding-top: 65px;">
        <v-list-item link @click="filter_pois('all')">
          <v-list-item-icon>
            <v-icon>mdi-all-inclusive</v-icon>
          </v-list-item-icon>
        </v-list-item >
          <v-list-item link @click="filter_pois('to_see')">
            <v-list-item-icon>
              <v-icon>mdi-eye</v-icon>
            </v-list-item-icon>
          </v-list-item >

          <v-list-item link @click="filter_pois('to_eat')">
            <v-list-item-icon>
              <v-icon>mdi-silverware-fork-knife</v-icon>
            </v-list-item-icon>
          </v-list-item >
          <v-list-item link @click="filter_pois('to_drink')">
            <v-list-item-icon>
              <v-icon>mdi-glass-cocktail</v-icon>
            </v-list-item-icon>
          </v-list-item >
          <v-list-item link @click="filter_pois('to_sleep')">
            <v-list-item-icon>
              <v-icon>mdi-bed</v-icon>
            </v-list-item-icon>
          </v-list-item >
          <v-list-item link @click="filter_pois('event')">
            <v-list-item-icon>
              <v-icon>mdi-calendar</v-icon>
            </v-list-item-icon>
          </v-list-item >
          <v-list-item link @click="filter_pois('others')">
            <v-list-item-icon>
              <v-icon>mdi-dots-horizontal</v-icon>
            </v-list-item-icon>
          </v-list-item >
        </v-list-item-group>
        </v-list>
    </v-navigation-drawer>
    <v-container ma-0 pa-0 titi fluid>

        <Map  :data="data" v-show="bottomNav == 'map'" :loading="loading" :setMap="setMap" :moveend="moveend"/>
        <List  :referentiel="referentiel_tags_colors" :filters="filters" :data="data" v-show="bottomNav == 'list'" />
    <v-bottom-navigation background-color="teal darken-2" dark app v-model="bottomNav">
        <v-btn value="map">
          <span class="baloo-text">{{ $t('map')}}</span>
          <v-icon>mdi-map</v-icon>
        </v-btn>

        <v-btn value="list">
          <span class="baloo-text"> {{ $t('list') }}</span>
          <v-icon>mdi-format-list-bulleted</v-icon>
        </v-btn>

    </v-bottom-navigation>
    </v-container>
  </div>

</template>
<script>
//import img from '@/assets/check.png';
import checkSvg from '@/assets/check.svg';
import {  GeoFirestore } from 'geofirestore';
//const GeoFirestore = import(/* webpackChunkName: "firebase" */'geofirestore')
//const firebase = import(/* webpackChunkName: "firebase" */'@firebase/app');
import firebase from '@firebase/app';
import (/* webpackChunkName: "firebase" */'@firebase/firestore');
//const firestore = import(/* webpackChunkName: "firebase" */'@firebase/firestore');

import Map from './map';
import List from './list';

export default {
  props: ['slug'],
  components: {Map, List},
  data: () => ({
    bottomNav: 'map',
    f: 0,
    filters: [],
    pos: null,
    loading: false,
    data: [],
    firestore: null,
    geofirestore: null,
    geocollection: null
  }),
  created() {
    this.map = null;

  },
  computed: {
    drawerFilter: {
      get(){
             return this.$store.state.filterPointsDrawer;
      },
      set(v){
        //this.$store.state.filterPointsDrawer = v;
             return v;
      }

    }
  },
  mounted() {
    this.filters.push('all');
    this.$store.dispatch('setFilterIcon', {state: true});
    this.firestore = firebase.firestore();
    this.geofirestore = new GeoFirestore(this.firestore);
    this.geocollection = this.geofirestore.collection('pois');
    let opt = {};
    navigator.geolocation.getCurrentPosition((pos) => {
      this.pos = pos.coords;
    }, () => {
      this.pos = false;
    }, opt);
    if(this.$route.hash.length > 0){
      this.$store.dispatch('openDialog', {id: this.$route.hash.split('#')[1]});
    }
  },
  methods: {
    checkMap() {
      if (this.pos && this.map) {
        if (this.slug == undefined) {
          this.map.setCenter([this.pos.longitude, this.pos.latitude]);
        }
      }
    },
    referentiel_tags_colors() {

      let o = [
        {n: 'to_see', t: ['NaturalSite', 'CulturalSite', 'Museum']},
        {n: 'to_eat', t: ['FoodEstablishment']},
        {n: 'to_drink', t: ['BarOrPub', 'BistroOrWineBar']},
        {n: 'to_sleep', t: ['Accommodation']},
        {n: 'event', t: ['Event']}
      ]
      return o;
    },
    thematic(tags_poi) {
      let t = this.referentiel_tags_colors().filter(t => {
        return t.t.filter(z => tags_poi.includes(z) ).length > 0;
      });
      if (t.length == 0) {
        return 'others';
      } else {
        return t[0].n;
      }

    },
    d() {
    let o = {"id": "pois", "type": "FeatureCollection", "features": [] } ;
    let x = null;
    let a = this.referentiel_tags_colors().filter(t => t.n == this.filters[0]);
    if (a.length > 0) {
       x = a[0].t;
    }
    if (this.filters[0] == 'others') {
      x = this.referentiel_tags_colors().reduce(function(list, ob){
  return list.concat(ob.t);
}, []);
    }
    if (this.data.length > 0) {
      o.features = this.data.filter((p) => {
        if (this.filters[0] == 'all') {
          return true;
        } else if (this.filters[0] == 'others') {
        return p.data().tags.filter(t =>  !x.includes(t)).length == p.data().tags.length ;
        } else  {
          return p.data().tags.filter(t =>  x.includes(t)).length > 0;

        }

      } ).map(p => {
        let d = p.data();
        if(!Object.keys(d).includes('name_fr')){
          d = d.d;
        }
        if (d !== undefined) {
          d.color = this.thematic(d.tags);
          d.done = this.$store.getters.user.loggedIn && this.$store.getters.user.data.validations.map(v => v.point).includes(p.id);
          d.id = p.id;
          return {  "type": "Feature",
          "geometry": {
            "type": "Point",
            "coordinates": [d.location.geoloc.lng, d.location.geoloc.lat]
            },
            "properties": d
          };
        }


      })
    }
    return o;


  },
  filter_pois(tag) {
    this.filters = [];
    this.filters.push(tag);
    this.map.getSource('pois').setData(this.d());

      //console.log(this.map.getLayer('unclustered-point_FoodEstablishment'));
      //this.map.setLayoutProperty('unclustered-point_FoodEstablishment', 'visibility', 'none');
  },
    distance(lat1, lon1, lat2, lon2, unit) {
  if ((lat1 == lat2) && (lon1 == lon2)) {
    return 0;
  }
  else {
    var radlat1 = Math.PI * lat1/180;
    var radlat2 = Math.PI * lat2/180;
    var theta = lon1-lon2;
    var radtheta = Math.PI * theta/180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = dist * 180/Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit=="K") { dist = dist * 1.609344 }
    if (unit=="N") { dist = dist * 0.8684 }
    return dist;
  }
},
  loadData(lat, lng, radius) {
    this.geocollection.near({ limit: 200, center: new firebase.firestore.GeoPoint(Number.parseFloat(lat), Number.parseFloat(lng)), radius: radius }).get().then((value) => {
      this.data = value.docs;
      this.map.getSource('pois').setData(this.d());
      this.loading = false;
    });
  },
  loadDataOffice() {
    this.geocollection = this.firestore.collection('pois');
      this.geocollection.where('d.ot','==', this.slug).get().then((snapshot) => {
        this.data = snapshot.docs;
        let bounds = [];
        this.data.forEach((p) => {
          let geo = p.data().d.geocoord;
          bounds.push([geo.lng, geo.lat]);
        });
        this.map.fitBounds(bounds);
        this.map.getSource('pois').setData(this.d());
        this.loading = false;
      }).catch(() => {

        this.loading = false;
      })
  },
    moveend(e) {
      if (e.map.getZoom() > 10 && !this.slug && !this.loading) {
        this.loading = true;
        let radius = this.distance(e.map.getBounds().getNorthEast().lat, e.map.getBounds().getNorthEast().lng, e.map.getCenter().lat, e.map.getCenter().lng, 'K');
        if (this.slug == undefined){
          this.loadData(e.map.getCenter().lat, e.map.getCenter().lng, radius);

        }
      }
    },
    setMap(m) {
      //let colorsTags = [{n: 'event', 'c': '#1518F0', t:['Event']}, {n: 'to_see', 'c': '#1518F0', t:['CulturalSite', 'Visit']}, {n: 'to_eat', 'c': '#E13E2B', t:['FoodEstablishment']}, {n: 'to_sleep', 'c':'#EDF015 ', t:['Accommodation']}];
      this.map = m;
      setTimeout(() => {
        this.map.resize();
      }, 200);
      this.checkMap();
      this.map.addSource('pois', {
        type: 'geojson',
        data: {
          "type": "FeatureCollection",
          "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
          "features": []
        },
        cluster: true,
        clusterMaxZoom: 11, // Max zoom to cluster points on
        clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
      });
      this.map.addLayer({
  id: "clusters",
  type: "circle",
  source: "pois",
  filter: ["has", "point_count"],
  paint: {
    "circle-color": [
      "step",
      ["get", "point_count"],
      "#00796b",
      100,
      "#00796b",
      750,
      "#00796b"
    ],
    "circle-radius": [
      "step",
      ["get", "point_count"],
      20,
      100,
      30,
      750,
      40
    ]
  }
});

this.map.addLayer({
id: 'cluster-count',
type: 'symbol',
source: 'pois',
filter: ['has', 'point_count'],
paint: {
  "text-color": "#ffffff"
},
layout: {
  'text-field': '{point_count_abbreviated}',
  'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
  'text-size': 12
}
});

/*Object.keys(colorsTags).forEach((v, z) => {
  let layer_id = 'unclustered-point_'+colorsTags[z].n;
  this.map.addLayer({
    id: layer_id,
    type: 'circle',
    source: 'pois',
  //filter: ['all',  ['!has', 'point_count'], ['in', 'PointOfInterest', 'tags'   ]],
  //filter: ['!', ['has', 'point_count']],
  filter:  ['in', colorsTags[z].t.toString(), ["get", "tags"] ],
  paint: {
  'circle-color': colorsTags[z].c,
  'circle-radius': 8,
  'circle-stroke-width': 1,
  'circle-stroke-color': '#fff'
  }

  });
  const self = this;
  this.map.on('click', layer_id, function(e) {
    let item =  e.features[0].properties;
    self.$store.dispatch('openDialog', {id: item.id, data: self.data.filter(d => d.id == item.id)[0].data()});
  });

});*/

this.map.addLayer({
  id: 'unclustered-points',
  type: 'circle',
  source: 'pois',
//filter: ['all',  ['!has', 'point_count'], ['in', 'PointOfInterest', 'tags'   ]],
filter: ['!', ['has', 'point_count']],

paint: {
'circle-color': ['match',
['get', 'color'],
'to_see', '#F0250E',
'to_sleep', '#29129D',
'to_eat', '#16C42E',
'event', '#EBDE0E',
 '#0E0D01'],
'circle-radius': 8,
'circle-stroke-width': 1,
'circle-stroke-color': '#fff'
}

});
let image = new Image(15, 15);
image.onload = ()=>this.map.addImage('check', image)
image.src = checkSvg;
/*this.map.loadImage(img,(e, i) => {
  console.log(e);
  if (!e) {
    this.map.addImage('check',i);
  }
  console.log(i);
})*/
this.map.addLayer({
  id: 'unclustered-done-points',
  type: 'symbol',
  source: 'pois',
//filter: ['all',  ['!has', 'point_count'], ['in', 'PointOfInterest', 'tags'   ]],
filter: ['get', 'done'],
'layout': {
'icon-image': 'check',
'icon-allow-overlap': true,
'text-size': 11,
'text-transform': 'uppercase',
'text-letter-spacing': 0.05,
'text-offset': [0, 1.5]
},
'paint': {
'text-color': '#202',
'text-halo-color': '#fff',
'text-halo-width': 2
}

});

const self = this;
this.map.on('click', 'unclustered-points', function(e) {
  let item =  e.features[0].properties;

  self.$store.dispatch('openDialog', {id: item.id, data: self.data.filter(d => d.id == item.id)[0].data()});
  self.$router.push({ hash: '#'+item.id });
});

this.loading = true;

let radius = this.distance(this.map.getBounds().getNorthEast().lat, this.map.getBounds().getNorthEast().lng, this.map.getCenter().lat, this.map.getCenter().lng, 'K');

      if (this.slug == undefined){
        this.loadData(this.map.getCenter().lat, this.map.getCenter().lng, radius);

      }  else {
        this.loadDataOffice(this.slug);
      }

    }
}
//this.map.fitBounds();
//console.log(this.map);

}
</script>
<style>
.titi {
  height: 100%;
}
</style>
